module.exports = __webpack_public_path__ + "static/media/exampleHeadshot.97d5591a.png";